import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="exclusive"
export default class extends Controller {
  static targets = ["dateStart", "dateEnd", "operator", "result", "gameValue", "rs", "button", "minGaran"];

  getSelectedRadioButton() {
    const selectedButton = this.buttonTargets.find(button => button.checked);
    return selectedButton ? selectedButton.value : undefined;
  }

  calculate(event) {
    event.preventDefault();

    const operatorId = this.operatorTarget.value;
    const startDate = this.dateStartTarget.value;
    const endDate = this.dateEndTarget.value;
    const game = this.getSelectedRadioButton();
    const rsExclusive = this.rsTarget.value;
    const minGaran = this.minGaranTarget.value;

    const isVerificationSuccessful = this.verifications(operatorId, startDate, endDate, game, rsExclusive, minGaran);
    if (!isVerificationSuccessful) {
      return;
    }

    fetch(`/bo/admin/exclusives/calculate_exclusive?operator=${operatorId}&start_date=${startDate}&end_date=${endDate}&game_id=${game}&rs_exclusive=${rsExclusive}`)
      .then(response => response.json())
      .then(data => {
        const formatter = new Intl.NumberFormat('es-ES', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        if (parseFloat(data.result_total) > parseFloat(minGaran)) {
          this.resultTarget.value = formatter.format(data.result_total);
        } else {
          this.resultTarget.value = formatter.format(minGaran);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  calculate_account_manager(event) {
    event.preventDefault();

    const operatorId = this.operatorTarget.value;
    const startDate = this.dateStartTarget.value;
    const endDate = this.dateEndTarget.value;
    const game = this.getSelectedRadioButton();
    const rsExclusive = this.rsTarget.value;
    const minGaran = this.minGaranTarget.value;

    const isVerificationSuccessful = this.verifications(operatorId, startDate, endDate, game, rsExclusive, minGaran);
    if (!isVerificationSuccessful) {
      return;
    }

    fetch(`/bo/account_manager/exclusives/calculate_exclusive?operator=${operatorId}&start_date=${startDate}&end_date=${endDate}&game_id=${game}&rs_exclusive=${rsExclusive}`)
      .then(response => response.json())
      .then(data => {
        const formatter = new Intl.NumberFormat('es-ES', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        if (parseFloat(data.result_total) > parseFloat(minGaran)) {
          this.resultTarget.value = formatter.format(data.result_total);
        } else {
          this.resultTarget.value = formatter.format(minGaran);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  calculate_explorer(event) {
    event.preventDefault();

    const operatorId = this.operatorTarget.value;
    const startDate = this.dateStartTarget.value;
    const endDate = this.dateEndTarget.value;
    const game = this.getSelectedRadioButton();
    const rsExclusive = this.rsTarget.value;
    const minGaran = this.minGaranTarget.value;

    const isVerificationSuccessful = this.verifications(operatorId, startDate, endDate, game, rsExclusive, minGaran);
    if (!isVerificationSuccessful) {
      return;
    }

    fetch(`/bo/explorer/exclusives/calculate_exclusive?operator=${operatorId}&start_date=${startDate}&end_date=${endDate}&game_id=${game}&rs_exclusive=${rsExclusive}`)
      .then(response => response.json())
      .then(data => {
        const formatter = new Intl.NumberFormat('es-ES', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        if (parseFloat(data.result_total) > parseFloat(minGaran)) {
          this.resultTarget.value = formatter.format(data.result_total);
        } else {
          this.resultTarget.value = formatter.format(minGaran);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  verifications(operatorId, startDate, endDate, game, rsExclusive, minGaran) {
    if (!operatorId) {
      alert("Por favor, completa el campo Operador.");
      return false;
    }
    if (!startDate) {
      alert("Por favor, selecciona la Fecha de inicio.");
      return false;
    }
    if (!endDate) {
      alert("Por favor, selecciona la Fecha de finalización.");
      return false;
    }
    if (!game) {
      alert("Por favor, selecciona un Juego.");
      return false;
    }
    if (!rsExclusive) {
      alert("Por favor, completa el campo RS Exclusivo.");
      return false;
    }
    if (!minGaran) {
      alert("Por favor, complete el campo Minimo Garantizado")
      return false
    }

    return true;
  }

}
